import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import _moment from 'proxies/dayjs';
import { AlertsService } from 'src/modules/base/services/alerts.service';
//import { packageData, packageJsonModel } from '../common/appointment.model';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { ModalService } from 'src/modules/base/services/modal.service';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { packageData, packageJsonModel } from 'src/modules/kx-shared/models/user'

@Component({
    selector: 'app-reschedulepackageslot',
    templateUrl: './reschedulepackageslot.component.html',
    styleUrls: ['./reschedulepackageslot.component.scss'],
    standalone: false
})
export class ReschedulepackageslotComponent implements OnInit {
  moment = _moment;
  package: packageJsonModel;
  packageData: packageData;
  data: any; facility_id: any;
  colorScheme: any = { "Slot Available": { "border": "2px solid #9b9b9b", "background": "#fff" }, "Single slot booked": { "border": "2px solid #FB9026", "background": "#FFFFF" }, "Over Booking Slot available": { "border": "2px solid #FB9026", "background": "#FB9026" }, "Slot full": { "border": "2px solid #B8E986", "background": "#B8E986" }, "VIP booking": { "border": "2px solid #4A90E2", "background": "#B8E986" }, "Off & others": { "border": "2px solid #C17FCE", "background": "#C17FCE" } }
  withoutslot: boolean = false;

  constructor(
    private loader: LoaderService,
    private baseService: BaseService,
    private appService: AppService,
    private alert: AlertsService,
    private dialog: DialogConfig,
    private dialogRef: DialogRef,
    private modalService: ModalService,
    public router: Router,
    public route: ActivatedRoute,
  ) {
    this.package = new packageJsonModel();
    this.packageData = new packageData();
  }

  ngOnInit(): void {
    this.data = this['dialog'].data.item
    this.packageData.slotDate = this.data.serviceDate;
    this.facility_id = this.data.facility_id;
    if (this.data.slotStartTime == "") {
      this.withoutslot = true
    }

    // this.getSlots()
  }



  getSlots() {
    this.loader.showSpinner()
    let slotDay = this.moment(this.packageData.slotDate).format("dd");
    let args = "slot_days:" + slotDay + ",slot_date:" + this.packageData.slotDate + ",serviceItemId:" + this.data.serviceItemId

    if (this.appService.getUniversalConfig('multi_care_type')) {
      args += ",care_type:" + this.appService.getDynamicFunctions("getCurrentCareType")
    }

    if (this.appService.isFacilityAware()) {
      args += ",facility_id:" + this.facility_id
    }

    if (this.data.reappliable_limit && this.data.reappliable_limit != this.data.reapply_left) {
      args += ",is_reappliable:true"
    } else {
      args += ",is_reappliable:false"
    }

    this.baseService.get("PACKAGE_SLOT", args, "package_slot", "facility-management").subscribe((result: any) => {
      this.loader.hideSpinner()
      if (result.errCode == -1) {
        this.alert.error(result.message);
        this.packageData.slots = [];
      } else {
        if (result.resource.length == 0) {
          this.alert.error("No Slots Found !!!")
          this.packageData.slots = {};
        } else {
          var that = this;
          result.resource.map(x => {
            x['serviceType_code'] = this.data.serviceType_code
            if (that.moment(x.slot_start_time).hour() < 12) {
              x['day_routine'] = "field.label.morning";
              x['priority'] = "";
            } else if (that.moment(x.event_start_time).hour() < 17) {
              x['day_routine'] = "field.label.afternoon";
              x['priority'] = "";
            } else {
              x['day_routine'] = "field.label.evening";
              x['priority'] = "";
            }
          })
          this.packageData.slots = {};
          [...new Set(result.resource.map(x => x.day_routine))].forEach((q: any) => {
            this.packageData.slots[q] = result.resource.filter(s => s.day_routine == q)
          });
          Object.keys(this.packageData.slots).forEach(x => {
            let obj = {};
            [...new Set(this.packageData.slots[x].map(x => x.priority))].forEach((q: any) => {
              obj[q] = this.packageData.slots[x].filter(s => s.priority == q)
            });
            this.packageData.slots[x] = obj
          })
        }
      }
    })
  }

  slotResult(slot: any) {
    this.packageData.slotId = slot.id;
    this.packageData.slotStartTime = slot.slot_start_time;
    this.packageData.slotEndTime = slot.slot_end_time;
    this.packageData.slotNo = slot.slotNo;
    this.packageData.over_booking_status = slot.slot_over_booking_status;
    this.updateSlot()
  }

  sendPickerResult(event: any) {
    this.packageData.slotDate = (this.moment(event.date).subtract(0, 'days').startOf('day').valueOf());
    if (this.withoutslot != true) {
      this.loader.showSpinner()
      this.getSlots()
    }
  }

  updateSlot() {
    const dialogRef = this.modalService.confirm('Confirm', 'Are you sure you want to book this slot ?', ModalSize.Sm);
    dialogRef.subscribe(result => {
      if (result) {
        this.loader.showSpinner();
        let datsource = this.dialog.data.action.datasource;
        this.CheckValidations(this.dialog.data.item, cb => {
          if (cb && cb != false) {
            let result: any = {};
            result['serviceRequestId'] = this.data.serviceRequestId;
            result['over_booking_status'] = this.packageData.over_booking_status;
            result['serviceDate'] = this.packageData.slotDate;
            result['slotId'] = this.packageData.slotId;
            result['slotNo'] = this.packageData.slotNo;
            result['id'] = this.data.id;
            result['slotStartTime'] = this.packageData.slotStartTime;
            result['slotEndTime'] = this.packageData.slotEndTime;
            result['is_group_limit_applicable'] = this.data.is_group_limit_applicable ? this.data.is_group_limit_applicable : false;
            result['facility_id'] = this.data.facility_id;
            result['package_type'] = this.data.package_type;
            result['package_type_code'] = this.data.package_type_code;
            this.baseService.action(result, datsource.action, datsource.application, datsource.resource).subscribe(data => {
              if (data.errCode == -1) {
                this.alert.error(data.message);
              } else {
                this.alert.success(data.message);
                this.dialogRef.close(data.resource[0]);
              }
              this.loader.hideSpinner();
            })
          }
          else {
            this.alert.error("You have booked Already This Slot.Kindly book Another Slot.");
            this.loader.hideSpinner();
            return false;
          }
        })

      }
    },
      () => { });
  }


  CheckValidations(data: any, cb) { // check same slot or same time 
    if (this.packageData.slotStartTime === this.data.slotStartTime) {
      cb(false)
    } else {
      cb(true)
    }
  }

}